import React, {  useRef } from 'react';
import assignedVia_1 from '../../assets/images/assignedVia_1.png';
import assignedVia_2 from '../../assets/images/assignedVia_2.png';
import assignedVia_3 from '../../assets/images/assignedVia_3.png';
import assignedVia_4 from '../../assets/images/assignedVia_4.png';
import assignMethodImg from '../../assets/images/personWhiteboard.png';
import Modal from '../Modal/index';
import CustomToast from '../Toast/index';
import { useAssignmentContext } from '../../pages/assignments/context';
import { useSaveAssignmentMethodMutation } from '../../features/authentication/assignmentApislice';
import { useNavigate } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

const assignedViaOptions = [
  { assignedViaId: 1, className: 'castle', name: 'Castle', image: assignedVia_1 },
  { assignedViaId: 2, className: 'google', name: 'Google Classroom', image: assignedVia_2 },
  { assignedViaId: 3, className: 'schoology', name: 'Schoology', image: assignedVia_3 },
  { assignedViaId: 4, className: 'canvas', name: 'Canvas', image: assignedVia_4 }
];

const Index = ({ showModal, setShowModal, assignmentId, navigateTo }) => {
  const [saveAssignmentMethod, saveAssignmentMethodResults] = useSaveAssignmentMethodMutation();

  const {
    setAssignmentAssignedViaDetails
  } = useAssignmentContext();
  const navigate = useNavigate();
  const assignmentMethodRef = useRef();

  async function handleSaveAssignmentMethod() {
    try {
      await saveAssignmentMethod({
        assignmentIds: [assignmentId],
        assignedViaId: assignmentMethodRef.current.value
      }).unwrap();

      var assignedOption = assignedViaOptions.find(
        (c) => c.assignedViaId == assignmentMethodRef.current.value
      );
      setAssignmentAssignedViaDetails({
        id: assignedOption.assignedViaId,
        name: assignedOption.name
      });
      setShowModal(false);
      CustomToast('The assignment method has been updated', 'success');
    } catch (ex) {
      CustomToast('Something went wrong, could not update assignment method', 'error');
      console.log(ex);
    }
  }


  return (
    <Modal
      contentWidth="40%"
      isOpen={showModal}
      titleName={'Assignment Method'}
      onClose={() => {navigateTo ? navigate(navigateTo) : setShowModal(false);}}
      disableBackdropClose={true}>
      <div className="d-flex flex-column align-items-center">
        <div
          className="mb-3"
          style={{
            backgroundImage: `url(${assignMethodImg})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100%',
            height: '130px',
            width: '199px'
          }}></div>
        <div>How will you assign this assignment?</div>
        <div className="d-flex flex-row w-50 my-4 align-items-center justify-content-evenly">
          <span>Assigned Via</span>
          <Form.Select ref={assignmentMethodRef} style={{ maxWidth: '50%' }} defaultValue="1">
            {assignedViaOptions.map((item, index) => {
              return (
                <option key={`assignmentMethodKey${index}`} value={item.assignedViaId}>
                  {item.name}
                </option>
              );
            })}
          </Form.Select>
        </div>
        <div className="d-flex flex-row w-50 justify-content-evenly">
          <Button
            variant="castleGray"
            style={{ width: '45%' }}
            onClick={() => {navigateTo ? navigate(navigateTo) : setShowModal(false);}}>
            Cancel
          </Button>
          <Button
            variant="castleRed"
            style={{ width: '45%' }}
            onClick={(e) => handleSaveAssignmentMethod(e)}
            disabled={saveAssignmentMethodResults.isLoading}>
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};

Index.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  assignmentId: PropTypes.number,
  navigateTo: PropTypes.string
};

export default Index;
